import { Navigate, Route, Routes } from "react-router-dom";

import { AppShell } from "./components/AppShell";
import { AuthGate } from "./lib/auth";
import { Login } from "./pages/Login";
import { MagicLink } from "./pages/MagicLink";
import { AuditList } from "./pages/Audit/List";
import { TelemetryOverview } from "./pages/Telemetry/Overview";
import { EngagementsList } from "./pages/Engagements/List";
import { EngagementDetail } from "./pages/Engagements/Detail";
import { PersonasList } from "./pages/Personas/List";
import { PersonaDetail } from "./pages/Personas/Detail";
import { TargetsIndex } from "./pages/Targets/Index";
import { TestPool } from "./pages/Targets/TestPool";
import { GroupsList } from "./pages/Groups/List";
import { GroupDetail } from "./pages/Groups/Detail";
import { LiveCallsList } from "./pages/LiveCalls/List";
import { LiveCallDetail } from "./pages/LiveCalls/Detail";
import { TemplatesList } from "./pages/Templates/List";
import { TemplateEditor } from "./pages/Templates/Editor";
import { CampaignsList } from "./pages/Campaigns/List";
import { CampaignDetail } from "./pages/Campaigns/Detail";
import { SendingProfilesList } from "./pages/SendingProfiles/List";
import { Settings } from "./pages/Settings/Settings";

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/auth" element={<MagicLink />} />
      <Route
        path="/"
        element={
          <AuthGate>
            <AppShell />
          </AuthGate>
        }
      >
        <Route index element={<Navigate to="/engagements" replace />} />
        <Route path="engagements" element={<EngagementsList />} />
        <Route path="engagements/:id" element={<EngagementDetail />} />
        <Route path="campaigns" element={<CampaignsList />} />
        <Route path="campaigns/:id" element={<CampaignDetail />} />
        <Route path="personas" element={<PersonasList />} />
        <Route path="personas/:id" element={<PersonaDetail />} />
        <Route path="templates" element={<TemplatesList />} />
        <Route path="templates/new" element={<TemplateEditor />} />
        <Route path="templates/:id" element={<TemplateEditor />} />
        <Route path="targets" element={<TargetsIndex />} />
        <Route path="test-pool" element={<TestPool />} />
        <Route path="groups" element={<GroupsList />} />
        <Route path="groups/:id" element={<GroupDetail />} />
        <Route path="sending-profiles" element={<SendingProfilesList />} />
        <Route path="live-calls" element={<LiveCallsList />} />
        <Route path="live-calls/:id" element={<LiveCallDetail />} />
        <Route path="audit" element={<AuditList />} />
        <Route path="telemetry" element={<TelemetryOverview />} />
        <Route path="settings" element={<Settings />} />
      </Route>
      <Route path="*" element={<Navigate to="/engagements" replace />} />
    </Routes>
  );
}
